/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Invoicestatusopen2Inputs */

const en_invoicestatusopen2 = /** @type {(inputs: Invoicestatusopen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open`)
};

const de_invoicestatusopen2 = /** @type {(inputs: Invoicestatusopen2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offen`)
};

/**
* | output |
* | --- |
* | "Open" |
*
* @param {Invoicestatusopen2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const invoicestatusopen2 = /** @type {((inputs?: Invoicestatusopen2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Invoicestatusopen2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_invoicestatusopen2(inputs)
	return de_invoicestatusopen2(inputs)
});
export { invoicestatusopen2 as "invoiceStatusOpen" }